// extracted by mini-css-extract-plugin
export var alt = "OurBrands-module--alt--52185";
export var container = "OurBrands-module--container--7fe43";
export var customCol = "OurBrands-module--customCol--e8656";
export var description = "OurBrands-module--description--062c7";
export var desktopOnly = "OurBrands-module--desktopOnly--16b5c";
export var logoLink = "OurBrands-module--logoLink--c460f";
export var main = "OurBrands-module--main--05a98";
export var mobileOnly = "OurBrands-module--mobileOnly--22add";
export var styledContainer = "OurBrands-module--styledContainer--788d4";
export var styledRow = "OurBrands-module--styledRow--d0d14";
export var textCol = "OurBrands-module--textCol--f9c6a";
export var textLeft = "OurBrands-module--textLeft--f0b30";
export var visuallyHidden = "OurBrands-module--visuallyHidden--7774a";